import store from "../index";
import { AUTH_USER_GET } from "Public/store/modules/auth";

const checkUserStore = (resolve) => {
  if (store.getters[AUTH_USER_GET].id) {
    resolve();
  } else {
    setTimeout(() => {
      checkUserStore(resolve);
    }, 250);
  }
};

export const checkUserStoreReady = () =>
  new Promise((resolve) => checkUserStore(resolve));
